<hyperkit-dialog class="hyperkit-component" [headerText]="options.headerText">
  <hyperkit-breadcrumb-list
    class="breadcrumb-list"
    [items]="breadcrumbs()"
    (breadcrumbClick)="onBreadcrumbClick($event)">
  </hyperkit-breadcrumb-list>

  <ng-container *ngIf="!captureData()">
    <hyperkit-typography class="dialog-description" display="block" variant="body2" align="left" color="body">
      Please provide the details of the data you are looking to capture. Based on your input, we will suggest the appropriate pivot queries.
    </hyperkit-typography>

    <form [formGroup]="dataCaptureForm">
      <hyperkit-input class="hyperkit-component" type="text" id="hostname" label="Hostname" placeholder="Enter the host machine name or IP address." formControlName="hostname"></hyperkit-input>

      <hyperkit-input class="hyperkit-component" type="text" id="processName" label="Process Name" placeholder="Provide the name of the process you're investigating." formControlName="processName"></hyperkit-input>

      <hyperkit-input class="hyperkit-component" type="text" id="processID" label="Process ID" placeholder="Enter the process ID related to the hostname." formControlName="processID"></hyperkit-input>

      <hyperkit-input class="hyperkit-component" type="text" id="parentProcessName" label="Parent Process Name" placeholder="If applicable, specify the parent process name." formControlName="parentProcessName"></hyperkit-input>

      <hyperkit-input class="hyperkit-component" type="text" id="parentProcessID" label="Parent Process ID" placeholder="Provide the parent process ID if available." formControlName="parentProcessID"></hyperkit-input>

      <div class="dialog-footer">
        <!-- <hyperkit-button
          *ngIf="isDemo"
          color="tertiary"
          variant="standard"
          text="Auto-Fill for Demo"
          icon="play"
          (click)="fillFormForDemo()">
        </hyperkit-button> -->

        <hyperkit-button color="secondary" text="Skip" (click)="onSkip()"></hyperkit-button>
        <hyperkit-button class="hyperkit-component" color="primary" text="Continue" (click)="onContinue()"></hyperkit-button>
      </div>
    </form>

    <hyperkit-error *ngIf="error()" [error]="error()"></hyperkit-error>
  </ng-container>

  <ng-container *ngIf="captureData()">
    <hyperkit-typography class="dialog-description" variant="body2" align="left" color="body">
      Based on the data you’ve provided, we suggest the following pivot queries to guide your investigation. Select the one that best fits your needs or explore other options.
    </hyperkit-typography>

    <div class="pivot-search-container">
      <hyperkit-search-input
        [placeholder]="'Search pivots...'"
        [text]="pivotSearchTerm()"
        (textChange)="pivotSearchTerm.set($event)"
        class="search-bar">
      </hyperkit-search-input>
    </div>

    <div class="pivot-scroll-container">
      <div class="pivot-cards-container">
        <pivot-card
        *ngFor="let item of filteredPivotItems(); trackBy: trackById"
        [title]="item.title"
        [description]="item.description"
        [selected]="selectedPivotItems().has(item.id)"
        [source]="item.source"
        (pivotSelection)="togglePivotSelection(item)">
      </pivot-card>
        </div>
    </div>

    <div class="dialog-footer">
      <hyperkit-button color="secondary" text="Back" (click)="goBack()"></hyperkit-button>
      <hyperkit-button class="send-button hyperkit-component" color="primary" text="Add Pivots" (click)="onSubmit()"></hyperkit-button>
    </div>
  </ng-container>
</hyperkit-dialog>